// extracted by mini-css-extract-plugin
module.exports = {"root":"root__RpMyS","header":"header__1YsPs","footer":"footer__N4n86","content":"content__fWkyr"};